import React from 'react';
import { Star, Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  city: string;
  content: string;
  imageInitial: string;
}
export function TestimonialCard({
  name,
  age,
  city,
  content,
  imageInitial
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-2xl shadow-md border border-purple-100 relative" data-id="element-16">
      <Quote className="absolute top-4 right-4 w-8 h-8 text-purple-100" data-id="element-17" />

      <div className="flex items-center gap-1 mb-4" data-id="element-18">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-19" />)}
      </div>

      <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-20">"{content}"</p>

      <div className="flex items-center gap-3" data-id="element-21">
        <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-700 font-bold" data-id="element-22">
          {imageInitial}
        </div>
        <div data-id="element-23">
          <h4 className="font-bold text-gray-900 text-sm" data-id="element-24">
            {name}, {age} años
          </h4>
          <p className="text-xs text-gray-500" data-id="element-25">{city}</p>
        </div>
      </div>
    </div>;
}